import { useState } from 'react';
import { Lock, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './AdminAuth.css';

const AdminAuth = ({ onSuccess, onCancel }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      if (username === 'admin' && password === 'FidLogic123') {
        onSuccess();
      } else {
        setError('Invalid credentials. Redirecting to home...');
        setUsername('');
        setPassword('');
        // Redirect to home after showing error
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
      setIsLoading(false);
    }, 500);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="admin-auth-overlay" onClick={handleBackdropClick}>
      <div className="admin-auth-modal">
        {/* Close Button */}
        <button 
          className="auth-close-btn" 
          onClick={onCancel}
          aria-label="Close"
          disabled={isLoading}
        >
          <X size={24} />
        </button>

        {/* Modal Header */}
        <div className="auth-header">
          <div className="auth-icon-wrapper">
            <Lock size={32} />
          </div>
          <h2>Admin Access Required</h2>
          <p className="auth-subtitle">Enter your credentials to access QR codes</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="auth-form">
          {/* Username Field */}
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              disabled={isLoading}
              autoFocus
              required
            />
          </div>

          {/* Password Field */}
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={isLoading}
              required
            />
          </div>

          {/* Error Message */}
          {error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
          )}

          {/* Buttons */}
          <div className="form-actions">
            <button
              type="submit"
              className="submit-btn"
              disabled={isLoading}
            >
              {isLoading ? 'Verifying...' : 'Access QR Codes'}
            </button>
            <button
              type="button"
              className="cancel-btn"
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>

        {/* Footer Info */}
        <div className="auth-footer">
          <p>🔒 This section is protected for authorized users only</p>
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;
